import { Component, createRef } from "react";
import ValuationStateHelper from "src/utils/ValuationStateHelper";
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler";
import StateConstants from "src/states/StateContstants";
import ApiHandler from "src/api/ApiHandler";
import ComparableHome from "src/components/comparable_homes/ComparableHome";
import PremiumGate from "src/components/premium/PremiumGate";
import UserFeatureHelper from "src/utils/UserFeatureHelper";
import "src/components/comparable_homes/ComparableHome.css";

class ComparableHomesWidget extends Component<any> {
    stateHandler: EventAdaptingStateHandler
    apiHandler: ApiHandler
    carouselRef = createRef<HTMLDivElement>()

    static FREE_TIER_COMPARABLE_LIMIT = 1

    constructor(props: any) {
        super(props)
        this.stateHandler = props.stateHandler
        this.apiHandler = props.apiHandler
        this.removeComparableHome = this.removeComparableHome.bind(this)
        this.updateValuation = this.updateValuation.bind(this)
        this.stateHandler.addListener(StateConstants.COMPARABLE_HOMES_STATE, (state: any) => {
            this.setState({ comparableHomes: state })
        })
        this.stateHandler.addListener(StateConstants.MAP_MARKER_HOVER, (state: any) => {
            this.setState({
                hoverMarkerId: state
            });
        });
        this.stateHandler.addListener(StateConstants.USER_FEATURES, () => {
            this.setState({});
        });
    }

    updateValuation() {
        this.stateHandler.set(StateConstants.SHOULD_UPDATE_VALUATION, true)
    }

    removeComparableHome(id: string) {
        ValuationStateHelper.removeComparableHome(this.stateHandler, id);
        this.stateHandler.set(StateConstants.MAP_MARKER_HOVER, null)
        this.stateHandler.set(StateConstants.REMOVED_HOMES, [...this.stateHandler.get(StateConstants.REMOVED_HOMES), id])
        this.updateValuation()
    }

    scrollCarouselToTop = () => {
        this.carouselRef.current?.scrollTo({ top: 0, behavior: "smooth" })
    }

    getComparableHomeCards() {
        let comparableHomes = this.stateHandler.get(StateConstants.COMPARABLE_HOMES_STATE)
        let comparableAddresses = comparableHomes?.["comparable_addresses"] ?? []
        let comparableHomeCards = []
        const canSeeAll = UserFeatureHelper.hasFeature(this.stateHandler, UserFeatureHelper.ALL_COMPARABLES)
        const canRemove = UserFeatureHelper.hasFeature(this.stateHandler, UserFeatureHelper.REMOVE_COMPARABLES)

        const hoveredId = this.stateHandler.get(StateConstants.MAP_MARKER_HOVER)
        if (hoveredId != null) {
            let highlightedComparableHome = comparableAddresses.find((comparableHome: any) => comparableHome["id"] === hoveredId)
            if (highlightedComparableHome) {
                comparableHomeCards.push(
                    <ComparableHome
                        key={highlightedComparableHome["id"]}
                        comparableHome={highlightedComparableHome}
                        onRemove={this.removeComparableHome}
                        hideRemoveButton={!canRemove}
                        stateHandler={this.stateHandler}
                        apiHandler={this.apiHandler}
                        onCardSelect={this.scrollCarouselToTop}
                    />
                )
            }
        }

        for (let comparableAddress of comparableAddresses) {
            if (comparableAddress["id"] === hoveredId) {
                continue
            }
            if (comparableAddress["sv"] === false) {
                continue
            }
            comparableHomeCards.push(
                <ComparableHome
                    key={comparableAddress["id"]}
                    comparableHome={comparableAddress}
                    onRemove={this.removeComparableHome}
                    hideRemoveButton={!canRemove}
                    stateHandler={this.stateHandler}
                    apiHandler={this.apiHandler}
                    onCardSelect={this.scrollCarouselToTop}
                />
            )
        }
        return comparableHomeCards
    }

    render() {
        let allCards = this.getComparableHomeCards()
        const canSeeAll = UserFeatureHelper.hasFeature(this.stateHandler, UserFeatureHelper.ALL_COMPARABLES)

        if (!allCards || allCards.length === 0) {
            return (
                <div className="comparable-homes empty-state">
                    <div className="empty-message">
                        <h3>No Comparable Homes</h3>
                        <p>Comparable homes will appear here once you add them to your valuation analysis.</p>
                    </div>
                </div>
            )
        }

        const visibleCards = canSeeAll ? allCards : allCards.slice(0, ComparableHomesWidget.FREE_TIER_COMPARABLE_LIMIT)
        const lockedCards = canSeeAll ? [] : allCards.slice(ComparableHomesWidget.FREE_TIER_COMPARABLE_LIMIT)
        const lockedCount = lockedCards.length

        return (
            <div className="comparable-homes">
                <div className="widget-header">
                    <h3 className="widget-title">Comparable Homes</h3>
                    <p className="widget-subtitle">Recent sales in the area for comparison</p>
                </div>
                <div className="table-container" ref={this.carouselRef}>
                    {visibleCards}
                    {lockedCount > 0 && (
                        <>
                            <PremiumGate
                                stateHandler={this.stateHandler}
                                apiHandler={this.apiHandler}
                                lockedMessage={`Unlock and filter ${lockedCount} more comparables`}
                            >
                                <div></div>
                            </PremiumGate>
                            <div className="comparable-homes-locked-preview" aria-hidden="true">
                                {lockedCards}
                            </div>
                        </>
                    )}
                </div>
            </div>
        )
    }
}

export default ComparableHomesWidget
